import React from 'react';
import './LogoutModal.css';

const LogoutModal = ({ open, onCancel, onConfirm }) => {
  if (!open) return null;
  return (
    <div className="logout-modal-overlay" onClick={onCancel}>
      <div className="logout-modal-dialog" onClick={e => e.stopPropagation()}>
        <div className="logout-modal-title">בטוח להתנתק?</div>
        <div className="logout-modal-actions">
          <button className="logout-modal-btn logout-modal-cancel" onClick={onCancel}>ביטול</button>
          <button className="logout-modal-btn logout-modal-confirm" onClick={onConfirm}>אישור</button>
        </div>
      </div>
    </div>
  );
};

export default LogoutModal;
